// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"Footer_footerWrapper__2mEC9","footerBlock":"Footer_footerBlock__1pwjd"};